import { ApplyReasonResVo } from '@/apis/afterSales/afterSales.interface';
import Expand from '@/assets/icons/chevron-down.svg';
import { FormControl, MenuItem, Radio, Select, SelectChangeEvent } from '@mui/material';
import { observer } from 'mobx-react';
import styles from './index.module.scss';

const CustomIcon: React.FC = (props) => <Expand {...props} />;

interface commonSelectProps {
  selectValue: string;
  selectList: ApplyReasonResVo[];
  selectChangeHandler: (value: string) => void;
  placeholder?: string;
}

const commonSelect: React.FC<commonSelectProps> = observer(
  ({ selectValue, selectList, selectChangeHandler, placeholder }) => {
    // if (!selectList?.length) {
    //   return null;
    // }
    const handleChange = (event: SelectChangeEvent) => {
      selectChangeHandler && selectChangeHandler(event.target.value);
    };

    return (
      <div className={styles.select_wrap}>
        <FormControl fullWidth={true}>
          <Select
            value={selectValue}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            renderValue={(value: string) => {
              if (value) {
                const selected = selectList.find((item) => item.reasonId === value);
                return <>{selected?.reasonName}</>;
              } else {
                return <span className={styles.placeholder_style}>{placeholder}</span>;
              }
            }}
            IconComponent={CustomIcon}
          >
            {selectList.map((item, index) => {
              return (
                <MenuItem
                  value={item.reasonId}
                  key={index}
                  sx={{
                    padding: '7px 12px 7px 19px',
                    marginBottom: '8px',
                    fontSize: '14px',
                    '.MuiSvgIcon-fontSizeSmall': {
                      fontSize: '16px',
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&:first-child': {
                      marginTop: '4px',
                    },
                    '&:last-child': {
                      marginBottom: '4px',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <Radio checked={item.reasonId === selectValue} size='small' disableRipple/>
                  <span className={styles.item_style}>{item.reasonName}</span>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    );
  },
);

export default commonSelect;
